<template>
	<div class="mt-4">
		<h4>{{$t('settings')}}</h4>

			<div class="app-panel container bg-white my-4 py-4">
			<FeedbackMessage/>
			<div>... irgend welche Einstellungen</div>
			
			<PreferFrontCameraSwitch />
			<ToDashboard class="mt-4"/>
			
			</div>
	</div>
</template>

<script>
import PreferFrontCameraSwitch from './PreferFrontCameraSwitch'
import FeedbackMessage from '@/components/FeedbackMessage'
import ToDashboard from './ToDashboard.vue'

export default {
	components: { 
		FeedbackMessage, ToDashboard, PreferFrontCameraSwitch
},
}
</script>

<style scoped>
.with-header-offset{
	padding-top: 6rem;
}
</style>